const AUTOMATION_PARAMS = {
  AllowWhatsappTemplate: true,
  TicketAutomationTypeCode: "1",
  AutomationCodeListExclude: ["15", "19"],
  Enable: true,
};

export const useAutomation = () => {
  return { automationParams: AUTOMATION_PARAMS };
};
